import $ from 'jquery';
import 'lightgallery';
import 'lg-video';

class Banner {
  constructor(el) {
    this.$el = $(el);
    this.videoUrl = this.$el.data('video-url');
    this.$lightBox = this.$el.find('.js-lightbox');
    this.init();
  }

  init() {
    this.$lightBox.lightGallery();
  }
}

const initBanners = function() {
  let eventsSliders = $('.js-video-banner');
  eventsSliders.each(function() {
    new Banner(this);
  });
};

export default initBanners;
